import * as useCases from 'core/use-cases';

export const rootReducer = useCases.utilities.combineReducers({
  app: useCases.app.reducer,
  cart: useCases.cart.reducer,
  catalog: useCases.catalog.reducer,
  checkout: useCases.checkout.reducer,
  combo: useCases.combo.reducer,
  content: useCases.content.reducer,
  order: useCases.order.reducer,
  router: useCases.router.reducer,
  search: useCases.search.reducer,
  sections: useCases.sections.reducer,
  settings: useCases.settings.reducer,
  showcases: useCases.showcases.reducer,
  user: useCases.user.reducer,
  version: useCases.version.reducer,
  shippingModel: useCases.shippingModel.reducer,
  productDetail: useCases.productDetail.reducer,
});
